import React from "react";
import { Route } from "react-router-dom";
import AuthLayout from "./components/Layout/AuthLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import HomePage from "./pages/HomePage";
import Target from "./pages/Content/Target";
import Industries from "./pages/Content/Industries";
import DailyViralFeed from "./pages/Feed/DailyViralFeed";
import InnovationFeed from "./pages/Feed/InnovationFeed";
import ContentGenerator from "./pages/GenerativeFeature/ContentGenerator";
import SentimentAnalyser from "./pages/GenerativeFeature/SentimentAnalyser";
import Invite from "./pages/Invite";
import Boards from "./pages/Boards";
import DesignerPage from "./pages/DesignerPage";
import FeatureTracking from "./pages/FeatureTracking";
import AcceptInvitation from "./pages/auth/AcceptInvitation";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import PrivateRoute from "./pages/auth/PrivateRoute";
import RoleBasedRoute from "./pages/auth/RoleBasedRoute";
import Login from "./pages/auth/Login";
import NotFound404 from "./pages/NotFound404";
import BoardImages from "./pages/Boards/BoardImages";
import Tickets from "./pages/Tickets";
import ReviewReport from "./components/Tickets/ReviewReport";
import ExpandViewOverallAnalysis from "./components/DesignerPage/TrendsSidebar/ExpandedViewOverallAnalysis";
import ExpandViewTrendCurves from "./components/DesignerPage/TrendsSidebar/ExpandedViewTrendCurves";
import TrendSnapshotDetails from "./components/DesignerPage/TrendsSnapshot/TrendSnapshotDetails";
import TrendSnapshot from "./pages/TrendSnapshot";
import Archive from "./pages/Archive";
import ExpandedViewColorAnalysis from "./components/DesignerPage/TrendsSidebar/ExpandedViewColorAnalysis";
import ExpandedViewSnapshotColorAnalysis from "./components/DesignerPage/TrendsSnapshot/ExpandedViewSnapshotColorAnalysis";
import ExpandedViewSnapShotOverallAnalysis from "./components/DesignerPage/TrendsSnapshot/ExpandedViewSnapShotOverallAnalysis";
import ExpandViewSnapshotTrendCurveAnalysis from "./components/DesignerPage/TrendsSnapshot/ExpandedViewSnapshotTrendCurves";

const routes = (
  isSidebarOpen: boolean,
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  trendsOpen: boolean,
  setTrendsOpen: React.Dispatch<React.SetStateAction<boolean>>
) => (
  <>
    <Route path="/auth" element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      <Route path="accept-invitation" element={<AcceptInvitation />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
    </Route>

    <Route
      path="/"
      element={
        <PrivateRoute>
          <DashboardLayout
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </PrivateRoute>
      }
    >
      <Route path="/" index element={<HomePage />} />
      <Route
        path="content/target"
        element={
          <RoleBasedRoute
            roles={["admin"]}
            element={<Target isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="content/industries"
        element={<RoleBasedRoute roles={["admin"]} element={<Industries />} />}
      />
      <Route
        path="feed/daily-viral-feed"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<DailyViralFeed />}
          />
        }
      />
      <Route
        path="feed/innovation-feed"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<InnovationFeed />}
          />
        }
      />
      <Route
        path="generative-feature/content-generator"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<ContentGenerator isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="generative-feature/sentiment-analyser"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<SentimentAnalyser isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="boards"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<Boards isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="boards/:boardId"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<BoardImages isSidebarOpen={isSidebarOpen} />}
          />
        }
      />

      <Route
        path="designer-page"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <DesignerPage
                isSidebarOpen={isSidebarOpen}
                trendsOpen={trendsOpen}
                setTrendsOpen={setTrendsOpen}
              />
            }
          />
        }
      />

      <Route
        path="designer-page/color-analysis"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <ExpandedViewColorAnalysis isSidebarOpen={isSidebarOpen} />
            }
          />
        }
      />
      <Route
        path="designer-page/overall-analysis"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <ExpandViewOverallAnalysis isSidebarOpen={isSidebarOpen} />
            }
          />
        }
      />
      <Route
        path="designer-page/archive"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<Archive isSidebarOpen={isSidebarOpen} />}
          />
        }
      />

      <Route
        path="designer-page/trend-curves"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<ExpandViewTrendCurves isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="feature-tracking"
        element={
          <RoleBasedRoute roles={["admin"]} element={<FeatureTracking />} />
        }
      />
      <Route
        path="invite"
        element={
          <RoleBasedRoute
            roles={["admin"]}
            element={<Invite isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="tickets"
        element={
          <RoleBasedRoute
            roles={["admin"]}
            element={<Tickets isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="tickets/review/:id"
        element={
          <RoleBasedRoute
            roles={["admin"]}
            element={<ReviewReport isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
      <Route
        path="trend-snapshot/details/:id"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <TrendSnapshotDetails
                isSidebarOpen={isSidebarOpen}
                trendsOpen={trendsOpen}
                setTrendsOpen={setTrendsOpen}
              />
            }
          />
        }
      />
      <Route
        path="trend-snapshot/details/color-analysis/:id"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <ExpandedViewSnapshotColorAnalysis
                isSidebarOpen={isSidebarOpen}
              />
            }
          />
        }
      />
      <Route
        path="trend-snapshot/details/overall-analysis/:id"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <ExpandedViewSnapShotOverallAnalysis
                isSidebarOpen={isSidebarOpen}
              />
            }
          />
        }
      />

      <Route
        path="trend-snapshot/details/Trend-Curve-analysis/:id"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={
              <ExpandViewSnapshotTrendCurveAnalysis
                isSidebarOpen={isSidebarOpen}
              />
            }
          />
        }
      />
      <Route
        path="trend-snapshot"
        element={
          <RoleBasedRoute
            roles={["admin", "forecaster"]}
            element={<TrendSnapshot isSidebarOpen={isSidebarOpen} />}
          />
        }
      />
    </Route>

    <Route path="*" element={<NotFound404 />} />
  </>
);

export default routes;
